import React, { useState } from "react";

const DEFAULT_FALLBACK_SRC =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==";

export interface ImageWithFallbackProps extends Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  "src" | "alt" | "onError"
> {
  src: string;
  alt: string;
  fallbackSrc?: string;
  onError?: (error: Event) => void;
}

export function ImageWithFallback({
  src,
  alt,
  fallbackSrc,
  onError,
  ...rest
}: ImageWithFallbackProps) {
  const [imageSrc, setImageSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    if (!hasError) {
      setImageSrc(fallbackSrc ?? DEFAULT_FALLBACK_SRC);
      setHasError(true);
    }
    onError?.(e.nativeEvent);
  };

  return <img src={imageSrc} alt={alt} onError={handleError} {...rest} />;
}

ImageWithFallback.displayName = "ImageWithFallback";
